module.exports = __webpack_public_path__ + "static/media/trait-icons-patience.d3a19f5b.svg";